import client from "./client";

export const runBackup = async (companyId) =>
  (await client.post("/backups", null, { params: companyId ? { company_id: companyId } : {} })).data;
export const listBackups = async (companyId) =>
  (await client.get("/backups", { params: companyId ? { company_id: companyId } : {} })).data;
export const backupLink = async (id) => (await client.get(`/backups/${id}/download`)).data;
export const backupFile = async (id) =>
  (await client.get(`/backups/${id}/file`, { responseType: "blob" })).data;
export const restoreBackup = async (id, targetCompanyId) =>
  (await client.post(`/backups/${id}/restore`, null, { params: { target_company_id: targetCompanyId } })).data;
export const repairBackup = async (id) => (await client.post(`/backups/${id}/repair`)).data;
export const runAllBackups = async () => (await client.post("/backups/run-all")).data;

export const uploadBackup = async (file, onProgress) => {
  const form = new FormData();
  form.append("file", file);
  const res = await client.post("/backups/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (event) =>
      onProgress?.(event.total ? Math.round((event.loaded * 100) / event.total) : 0),
  });
  return res.data;
};
